import { HttpClient } from '@angular/common/http';
import { ServiceOrganization } from './organization.service';
import { AbstractServiceOrganization } from './organization.service.abstract';
import { MockServiceOrganization } from './organization.service.mock';
import { Enums } from '../../enums/enums';
import { AbstractEndpoints } from '../endpoints/endpoints.service.abstract';
import { AppMonitoring } from '../../app-services/monitoring/monitor.app';
import { AppConfig } from '../../app-services/config/config.app';

export function FactoryServiceOrganization(
    httpClient: HttpClient, endpoints: AbstractEndpoints,
    appMonitoring: AppMonitoring, appConfig: AppConfig
): AbstractServiceOrganization {
    appMonitoring.logEvent('FactoryServiceOrganization', 'Organization Service Factory loaded');
    switch (appConfig.environment) {
        case Enums.Environments.MockData:
        case Enums.Environments.MockDataWithAuth:
            return new MockServiceOrganization();
        default:
            return new ServiceOrganization(endpoints, httpClient, appMonitoring);
    }
}
